import { Component, Input } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "app-distribution-policy-mor-content",
    templateUrl: "./distribution-policy-mor-content.component.html",
    styleUrls: ["./distribution-policy-mor-content.component.scss", "../legal-documents.scss"],
    standalone: false,
})
export class DistributionPolicyMorContentComponent {
    @Input() noOverflow: boolean = false;
    accountUid: string;
    annexVUrl: string = "/developers-distribution-policy-mor-annex-V";
    constructor(private route: ActivatedRoute) {}

    ngOnInit() {
        this.annexVUrl = `/developers-distribution-policy-mor-annex-V`;
        if (this.route.snapshot.queryParams.accountUid) {
            this.annexVUrl = `${this.annexVUrl}?accountUid=${this.route.snapshot.queryParams.accountUid}`;
        }
    }
}
